import request from './request';


export const getBanner = params => request({
    params: {
      mod: 'banner',
      ...params
    }
  })

export const getNews = params => request({
    params: {
      mod: 'news',
      ...params
    }
  })

export const getBannerS = params => request({
    params: {
      mod: 'small_banner',
      ...params
    }
  })

export const getGames = params => request({
    params: {
      mod: 'games',
      ...params
    }
  })